import styled from 'styled-components';

import { Button } from '@pkg/components/Sections/Profile/Buttons';

export const AnswerItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 20px;
    span {
        font-weight: bold;
    }
`;

export const AnswerItemDelete = styled.div`
    cursor: pointer;
    &:hover {
        transform: scale(1.1);
    }
`;

export const StyledButton = styled(Button)`
    &&& {
        margin-bottom: 15px;
    }
`;
